let colorOutput = true;
export const useColoredOutput = (flag) => {
    colorOutput = flag;
};
const format = {
    red: '\x1b[31m',
    yellow: '\x1b[33m',
    reset: '\x1b[0m'
};
export const red = (str) => (colorOutput ? format.red + str + format.reset : str);
export const yellow = (str) => (colorOutput ? format.yellow + str + format.reset : str);
export const info = (config, message) => {
    if (config.output.write) {
        console.info(message);
    }
};
//# sourceMappingURL=output.js.map